import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { Grid, Snackbar } from "@material-ui/core";
import Slider from "./home/Slider";
import Products from "./home/Products";
import FeaturedProducts from "./home/FeatureProducts";
import CartBtn from "./miniCart/CartBtn";
import { Alert } from "@material-ui/lab";

export default function ShopPage(data) {
  const myUser = useSelector((state) => state.auth.user);
  const history = useHistory();
  const [showInventoryBtn, setShowInventoryBtn] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showCheckoutBtn, setShowCheckoutBtn] = useState(false);

  useEffect(() => {
    if (!myUser?.shipping_detail || !myUser?.billing_detail) {
      setErrorMessage("Please fill shipping info and billing info first");
      setTimeout(() => {
        history.push("/settings");
      }, 1500);
    }
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Slider />
      </Grid>
      {/*
      <Grid item xs={12}>
        <FeaturedProducts />
      </Grid>
      */}
      <Grid item xs={12}>
        <Products />
      </Grid>
      <CartBtn
        showInventoryBtn={showInventoryBtn}
        showCheckoutBtn={showCheckoutBtn}
        setShowInventoryBtn={setShowInventoryBtn}
        setShowCheckoutBtn={setShowCheckoutBtn}
      />
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={errorMessage != ""}
        autoHideDuration={2000}
        onClose={(e, r) => {
          if (r == "timeout") setErrorMessage("");
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setErrorMessage("")}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
}

const useStyle = makeStyles((theme) => ({}));
